import React, { useEffect } from "react";

import "./App.css";
import { ToastContainer } from "react-toastify";
import { Route, Routes, useNavigate } from "react-router-dom";
import PrivateRoutes from "./utils/PrivateRoutes";
import PublicRoute from "./utils/PublicRoute";
import DashboardLayout from "./layouts/DashboardLayout";
import CardCheckRoutes from "./utils/CardCheck";
import { setApiNavigate } from "./services/interceptor";
import { publicRoutes, privateRoutes } from "./constants/Routes";

function App() {

    const navigate = useNavigate();
    useEffect(() => {
        setApiNavigate(navigate);
    }, [navigate]);
    return (
        <div className="h-full bg-white">
            <ToastContainer />
            <Routes>
                {/* public routes */}

                <Route element={<PublicRoute />}>
                    {publicRoutes.map(({ path, element }) => (
                        <Route key={path} path={path} element={element} />
                    ))}
                </Route>
            </Routes>
            <DashboardLayout>
                <Routes>
                    {/* private */}
                    <Route element={<PrivateRoutes />}>
                        <Route element={<CardCheckRoutes />}>
                            {privateRoutes.map(({ path, element }) => (
                                <Route key={path} path={path} element={element} />
                            ))}
                        </Route>
                    </Route>
                </Routes>
            </DashboardLayout>
        </div>
    );
}

export default App;
